const copyText = name => document.querySelector('[data-shopper-copy]')?.content.querySelector(`[data-${name}]`)?.textContent || '';
const canonicalProductUrl = handle => /^[a-z0-9-]+$/.test(handle || '') ? `https://excello.in/products/${handle}` : null;

function closeShare(root, restoreFocus = false) {
  root.querySelector('[data-share-menu]').hidden = true;
  const trigger = root.querySelector('[data-product-share]');
  trigger.setAttribute('aria-expanded', 'false');
  if (restoreFocus) trigger.focus();
}

function openShare(root, url) {
  const menu = root.querySelector('[data-share-menu]');
  menu.querySelector('[data-share-whatsapp]').href = `https://wa.me/?text=${encodeURIComponent(url)}`;
  menu.querySelector('[data-share-email]').href = `mailto:?subject=${encodeURIComponent(root.dataset.productTitle || '')}&body=${encodeURIComponent(url)}`;
  menu.hidden = false;
  root.querySelector('[data-product-share]').setAttribute('aria-expanded', 'true');
}

function supportsNativeShare(root, url) {
  if (typeof navigator.share !== 'function') return false;
  try {
    return !navigator.canShare || navigator.canShare({ title: root.dataset.productTitle || 'EXCELLO', url });
  } catch { return false; }
}

async function nativeShare(root, url) {
  closeShare(root);
  try {
    await navigator.share({ title: root.dataset.productTitle || 'EXCELLO', url });
  } catch (error) {
    if (error.name === 'NotSupportedError') openShare(root, url);
  }
}

async function copyLink(root, url) {
  const status = root.querySelector('[data-share-status]');
  const field = root.querySelector('[data-share-copy-field]');
  try {
    await navigator.clipboard.writeText(url);
    field.hidden = true;
    status.textContent = copyText('copied');
  } catch {
    field.hidden = false;
    field.value = url;
    field.focus();
    field.select();
    let copied = false;
    try { copied = document.execCommand('copy'); } catch {}
    field.hidden = copied;
    status.textContent = copied ? copyText('copied') : copyText('copy-failed');
  }
}

document.addEventListener('click', event => {
  const root = event.target.closest('.excello-product-tools');
  for (const other of document.querySelectorAll('.excello-product-tools')) if (other !== root) closeShare(other);
  if (!root) return;
  event.stopPropagation();
  const button = event.target.closest('button');
  if (!button) return;
  const trigger = root.querySelector('[data-product-share]');
  const url = canonicalProductUrl(trigger.dataset.productHandle);
  if (!url) return;
  if (button.matches('[data-product-share]')) {
    if (supportsNativeShare(root, url)) nativeShare(root, url);
    else if (!root.querySelector('[data-share-menu]').hidden) closeShare(root);
    else openShare(root, url);
  } else if (button.matches('[data-product-copy]')) copyLink(root, url);
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const root of document.querySelectorAll('.excello-product-tools')) if (!root.querySelector('[data-share-menu]').hidden) closeShare(root, true);
});

